import { createFileRoute, redirect } from '@tanstack/react-router'

import { movedToConsole } from '@/features/auth/require-session'

/** A car's old address: the console's for the operator, the evaluations for anyone else. */
export const Route = createFileRoute('/_app/market/specs/$specKey')({
  beforeLoad: ({ context, params }) =>
    movedToConsole(context.queryClient, () =>
      redirect({ to: '/platform/market/specs/$specKey', params, replace: true }),
    ),
})
